/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-perf/jsx-no-new-function-as-prop */
import React from 'react'
import {
  Text, Loader, Modal, FloatingInput, useResponsiveWrapperContext,
} from '@usap/uicomponents'
import {
  StyledContainer,
  StyledFooter,
  StyledFooterNote,
  StyledLastMileUpdateButton,
  StyledSpacer,
  StyledSubtitle,
  StyledZipContainer,
} from './AvailabilityWmo.css'
import DatesWmo from './DatesWmo'
import ButtonWmo from '../../../../../../../Wmo/ButtonWmo/ButtonWmo'

const lastMileModalStyle = { maxWidth: '440px', padding: '1.5rem 1.5rem 2.25rem' }
const lastMileModalStyleMobile = {
  width: '91.666667%', maxWidth: '343px', padding: '1.5rem 1.5rem 2.25rem',
}
const emptyStyle = {}

const AvailabilityWmo = props => {
  const {
    shippingOption,
    handleSubmitZip,
    handleChangeZip,
    zipCodeError,
    zipCode,
    showLoader,
    storedZipCode,
    storedCity,
    showPopup,
    shouldShowPopup,
    isEconomyShippingEnabled = false,
    unfoldedShippingConfig,
    isUnfoldedShippingEnabled = false,
    unfoldedShippingVariant,
    isProductValidForUnfoldedShipping = false,
    isLastMile = false,
  } = props

  const { size } = useResponsiveWrapperContext()

  let modalStyle = emptyStyle
  if (isLastMile) {
    modalStyle = size === 'small' ? lastMileModalStyleMobile : lastMileModalStyle
  }

  return (
    <Modal
      data-testid="cart_shipping_eta_modal"
      espp
      open={showPopup}
      onOpenChange={shouldShowPopup}
      header={`Shipping to ${storedCity}, ${storedZipCode}`}
      style={modalStyle}
      content={(
        <StyledContainer>
          {showLoader && <Loader />}
          <StyledSubtitle>
            Delivery options and speeds may vary for different locations
            {' '}
            <small>*</small>
          </StyledSubtitle>

          <StyledZipContainer $isLastMile={isLastMile}>
            <FloatingInput
              placeholder=" "
              label="Shipping ZIP code"
              value={zipCode}
              onBlur={handleChangeZip}
              onChange={handleChangeZip}
              isWmoEnabled
              required={false}
              onKeyUp={event => {
                if (event.keyCode === 13) handleSubmitZip()
              }}
            />
            <StyledLastMileUpdateButton $isLastMile={isLastMile}>
              <ButtonWmo
                id="submit"
                form="submitForm"
                variant="highlight"
                onClick={handleSubmitZip}
                disabled={!zipCode || zipCode === storedZipCode}
                label="Update"
                width={size === 'small' ? '100%' : '150px'}
                dataTestId="cart_shipping_eta_modal_cta"
              />
            </StyledLastMileUpdateButton>
          </StyledZipContainer>
          {zipCodeError !== '' && (
            <Text size="12px" color="red" data-testid="cart-zipcode-modal-error">
              {zipCodeError}
            </Text>
          )}

          <StyledSpacer />

          {/* {!shipNotifyForm && deliveryDates.length > 0 ? ( */}
          {shippingOption && (
            <DatesWmo
              shippingOption={shippingOption}
              isEconomyShippingEnabled={isEconomyShippingEnabled}
              unfoldedShippingConfig={unfoldedShippingConfig}
              isUnfoldedShippingEnabled={isUnfoldedShippingEnabled}
              unfoldedShippingVariant={unfoldedShippingVariant}
              isProductValidForUnfoldedShipping={isProductValidForUnfoldedShipping}
              isLastMile={isLastMile}
            />
          )}
          <StyledFooter>
            <StyledFooterNote>
              <small>*</small>
              {' '}
              {isLastMile
                ? 'Shipping calculator is not available for Alaska, Hawaii and other countries.'
                : 'Shipping is not available to Alaska, Hawaii, or any non-US countries.'}
              <br />
              <small>**</small>
              {' '}
              All available shipping options are displayed here and can be
              selected at checkout.
            </StyledFooterNote>
          </StyledFooter>
        </StyledContainer>
      )}
    />
  )
}

export default AvailabilityWmo
